import styled from 'styled-components'

export const CartItems = styled.div`
  grid-column-start: 2;
  grid-column-end: span 1;
  grid-row-start: 1;
  grid-row-end: span 1;

  @media (max-width: 1000px) {
    grid-column-start: 1;
    grid-row-start: 1;
  }
`
export const CartCheckout = styled.div`
  grid-column-start: 2;
  grid-column-end: span 1;
  grid-row-start: 2;
  grid-row-end: span 1;

  @media (max-width: 1000px) {
    grid-column-start: 1;
    grid-row-start: 3;
  }
`

export const Items = styled.div`
  & > div:nth-child(n + 3) {
    margin-top: 25px;
  }
`

export const MobileHeading = styled.div`
  display: none;
  margin-top: 20px;

  @media (max-width: 600px) {
    display: block;
  }
`

export const Feedback = styled.div`
  font-size: 24px;
  color: grey;

  & > a {
    color: grey;
  }
`

export const VelocityEarnCont = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const VirginEarnAmt = styled.div`
  background: linear-gradient(to right, #e10a0a, #512699);
  color: white;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  margin-left: auto;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 5px;
`

export const Divider = styled.hr`
  border-top: 0;
  border-bottom: 1px solid var(--grey-25);
`
